import { Component, AfterViewInit } from '@angular/core';

declare var google: any;

@Component({
  selector: 'app-mapview',
  templateUrl: './mapview.component.html',
  styleUrls: ['./mapview.component.scss']
})
export class MapviewComponent implements AfterViewInit {

  map: any;
  directionsService = new google.maps.DirectionsService();
  directionsRenderer = new google.maps.DirectionsRenderer();

  center = { lat: 17.123184, lng: 79.208824 };

  stops: string[] = [];

  ngAfterViewInit() {
    this.initMap();
  }

  initMap() {
    this.map = new google.maps.Map(document.getElementById("map"), {
      center: this.center,
      zoom: 7
    });
    this.directionsRenderer.setMap(this.map);
    this.generateRoute();
  }

  initAutocomplete(input: any) {
    const autocomplete = new google.maps.places.Autocomplete(input, {
      fields: ['formatted_address'],
      componentRestrictions: { country: 'in' }
    });

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      if (place.formatted_address) {
        input.value = place.formatted_address;
      }
    });
  }

  addLocation(location: string) {
    if (!location) return;
    this.stops.push(location);
  }

  removeLocation(index: number) {
    this.stops.splice(index, 1);
  }

  generateRoute() {
    // if (this.stops.length < 2) {
    //   console.log(this.stops);
      
    //   alert("Please enter at least 2 locations");
    //   return;
    // }

    this.stops = ['Hyderabad, Telangana, India','Yadagirigutta, Telangana 508115, India','Karimnagar, Telangana, India', 'Basar, Telangana 504101, India']

    const origin = this.stops[0];
    const destination = this.stops[this.stops.length - 1];
    const waypoints = this.stops.slice(1, -1).map(loc => ({ location: loc, stopover: true }));

    this.directionsService.route(
      {
        origin,
        destination,
        waypoints,
        travelMode: google.maps.TravelMode.DRIVING
      },
      (result: any, status: any) => {
        if (status === "OK") {
          this.directionsRenderer.setDirections(result);
        } else {
          console.error("Routing failed:", status);
        }
      }
    );
  }
}
